import { Fragment } from 'react';
import Modal from 'common/components/TouchpointEditor/components/TouchpointNodes/Modal';
import Logo from 'common/components/TouchpointEditor/components/TouchpointNodes/Logo';
import Headline from 'common/components/TouchpointEditor/components/TouchpointNodes/Headline/SubTypes/Headline.generic';
import TextParagraph from 'common/components/TouchpointEditor/components/TouchpointNodes/TextParagraph/SubTypes/TextParagraph.generic';
import Button from 'common/components/TouchpointEditor/components/TouchpointNodes/Button';
import CalendarAttachment from 'common/components/TouchpointEditor/components/TouchpointNodes/CalendarAttachment';
import TicketConfirmation from 'common/components/TouchpointEditor/components/TouchpointNodes/TicketConfirmation';
import SessionsSummary from 'common/components/TouchpointEditor/components/TouchpointNodes/SessionsSummary';

export const BLOCKS = {
    Fragment,
    Modal,
    Logo,
    Image: Logo,
    Headline,
    TextParagraph,
    Button,
    CalendarAttachment,
    TicketConfirmation,
    SessionsSummary,
};
